import React from "react";
import { faQuestionCircle } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Group, Stack, Text, TextInput, Tooltip } from "@mantine/core";
import { hasLength, useForm } from "@mantine/form";

import { slugifyNameForOrg } from "@shared/utils";

interface NewOrgFormProps {
  onSubmit: any;
  onBack: () => void;
  isSaving: boolean;
}

export const NewOrgForm: React.FC<NewOrgFormProps> = ({
  onSubmit,
  onBack,
  isSaving,
}) => {
  const form = useForm({
    initialValues: {
      name: "",
      source_id: "",
      source_type: "simple",
    },
    validate: {
      name: hasLength({ min: 1 }, "Enter a Semgrep Organization name"),
      source_type: hasLength({ min: 1 }, "Must be a valid source type"),
    },
    transformValues: (values) => ({
      name: values.name,
      source_id: values.source_id,
      source_type: values.source_type,
    }),
    validateInputOnChange: true,
  });

  return (
    <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
      <Stack w="100%">
        <TextInput
          label="Organization display name"
          required
          {...form.getInputProps("name")}
        />
        <TextInput
          label={
            <Tooltip
              multiline
              withinPortal
              w={250}
              label="The slug is a URL-compatible format of your display name. It will be used for your organization home page URL and for invoking the Semgrep API."
            >
              <Text inherit>
                Organization slug{" "}
                <FontAwesomeIcon icon={faQuestionCircle} fixedWidth />
              </Text>
            </Tooltip>
          }
          disabled
          value={slugifyNameForOrg(form.values.name || "")}
        />
        <Group justify="space-between" grow>
          <Button onClick={onBack}>Back</Button>
          <Button type="submit" disabled={isSaving}>
            Create
          </Button>
        </Group>
      </Stack>
    </form>
  );
};
